/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import { Button } from 'react-bootstrap';
import ItemTitle from './ItemTitle';

const EditApplication = (props) => {
    const { 
        i18n,
        editBtnAction,
        disabledEditBtn
    } = props;
    return i18n ? (
        <div className={"editApplication-body"}>
            <ItemTitle i18n={i18n.editAppTitle}/> 
            <Button
                aria-pressed={false}
                aria-disabled={disabledEditBtn}
                data-key={"editApplication-Btn"}
                bsStyle="info"
                disabled={disabledEditBtn}
                onClick={editBtnAction}>
                {i18n.editBtn}
            </Button>
        </div>
    ) : null;
};
export default EditApplication;


// WEBPACK FOOTER //
// ./src/views/Appointment/components/EditApplication.js